export const NEUTRAL_TEXT_COLORS = {
    50: "text-neutral-50",
    100: "text-neutral-100",
    200: "text-neutral-200",
    300: "text-neutral-300",
    400: "text-neutral-400",
    500: "text-neutral-500",
    600: "text-neutral-600",
    700: "text-neutral-700",
    800: "text-neutral-800",
    900: "text-neutral-900",
}

export const BLUE_TEXT_COLORS = {
    50: "text-blue-50",
    100: "text-blue-100",
    200: "text-blue-200",
    300: "text-blue-300",
    400: "text-blue-400",
    500: "text-blue-500",
    600: "text-blue-600",
    700: "text-blue-700",
    800: "text-blue-800",
    900: "text-blue-900",
}

export const RED_TEXT_COLORS = {
    50: "text-red-50",
    100: "text-red-100",
    200: "text-red-200",
    300: "text-red-300",
    400: "text-red-400",
    500: "text-red-500",
    600: "text-red-600",
    700: "text-red-700",
    800: "text-red-800",
    900: "text-red-900",
}

export const AMBER_TEXT_COLORS = {
    50: "text-amber-50",
    100: "text-amber-100",
    200: "text-amber-200",
    300: "text-amber-300",
    400: "text-amber-400",
    500: "text-amber-500",
    600: "text-amber-600",
    700: "text-amber-700",
    800: "text-amber-800",
    900: "text-amber-900",
}

export const HYERLINK_TEXT_COLOR = "text-blue-500 hover:text-blue-700";